import React, { useEffect, useState } from 'react'
import { Box, Modal } from '@mui/material'
import classNames from 'classnames/bind'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import styles from './PopupInputName.module.css'
import { EMOJI_REGEX } from '~/constants/regex'
import STORAGE_KEYS from '~/constants/localStorage'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { MERCHANT_TYPE } from '~/constants'
import { isSeparateOrder } from '~/utils'
import { selectPopupTopPage } from '~/redux/popupTopPageSlice'

const cx = classNames.bind(styles)

const MAX_LENGTH_INPUT = 100

// Popup dùng chung ở nhiều màn
const PopupInputName = () => {
  const { merchant_type, extraFeatures, separate_order, food_court_id } =
    useSelector(selectRestaurant) // Thông tin nhà hàng
  const isRestaurantType = merchant_type === MERCHANT_TYPE.RESTAURANT
  const [visible, setVisible] = useState(false)
  const { open } = useSelector(selectPopupTopPage)

  const { t, i18n } = useTranslation()
  const [enteredName, setEnteredName] = useState('')
  const isDisabledInput = !enteredName.trim()

  useEffect(() => {
    // Xử lý logic mở popup nhập tên user
    const userName = localStorage.getItem(STORAGE_KEYS.USER_NAME)
    const local = localStorage.getItem(STORAGE_KEYS.LOCALE)
    if (!local) return

    // Xử lý sau 2s mới bật popup lên
    const idTimer = setTimeout(() => {
      if (
        isRestaurantType &&
        !food_court_id &&
        isSeparateOrder(extraFeatures) &&
        separate_order &&
        !userName
      ) {
        setVisible(true)
      } else {
        setVisible(false)
      }
    }, 2000)

    // Thực hiện clear timeout trong trường hợp update dependencies
    return () => {
      clearTimeout(idTimer)
    }
  }, [extraFeatures, isRestaurantType, separate_order, food_court_id, i18n.language, open])

  const inputChangeNameHandler = (e) => {
    const { value } = e.target
    if (value.match(EMOJI_REGEX)) return

    setEnteredName(value)
  }

  const renderInputName = () => {
    return (
      <Box>
        <input
          maxLength={MAX_LENGTH_INPUT}
          autoComplete="off"
          type="text"
          placeholder={t('placeholder.your_name')}
          value={enteredName}
          name="name"
          className={cx('input')}
          onChange={inputChangeNameHandler}
        />
      </Box>
    )
  }

  // Hàm xử lý confirm. Lưu thông tin vào trong local storage
  const handleConfirm = () => {
    const userName = enteredName.trim()
    localStorage.setItem(STORAGE_KEYS.USER_NAME, userName)
    setVisible(false)
  }

  const renderButtonConfirm = () => {
    return (
      <button
        onClick={handleConfirm}
        className={cx('btn_confirm', {
          disabled: isDisabledInput,
        })}>
        {t('actions.confirm')}
      </button>
    )
  }

  if (!visible) return null

  return (
    <Modal open={true}>
      <Box className={cx('wrapper')}>
        {/* Box toàn text */}
        <Box>
          <Box className={cx('title')}>{t('titles.input_a_name')}</Box>
          <Box className={cx('question')}>{t('titles.why_we_need_it')}</Box>
          <Box className={cx('desc')}>{t('descriptions.input_a_name')}</Box>
        </Box>

        {/* Input, Button */}
        <Box>
          {renderInputName()}
          {renderButtonConfirm()}
        </Box>
      </Box>
    </Modal>
  )
}

export default PopupInputName
